import { stubFalse } from 'lodash';
import { reject } from 'lodash';
import groupBy from 'lodash/groupBy.js';
import map from 'lodash/map.js';
import React from 'react';
import { Select } from '../../../../base-components/Select/index.js';
import { ExtraProps } from '../../../../base-components/Select/index.js';
import { Block } from '../../../../types/entities.js';
import { useMatchesLabel } from '../../hooks/useMatchesLabel/index.js';
import { useMultipleValue } from '../../hooks/useMultipleValue.js';

interface BlockOption {
  value: number;
  label: string;
  group: string;
  matches?: number;
}

interface GroupedBlockOption {
  label: string;
  options: BlockOption[];
}

export interface Props {
  instanceId: string;
  blocks: Block[];
  value: Block[];
  onChange: (value: Block[]) => void;
  excludeFormation?: boolean;
  excludeFinished?: boolean;
  className?: string;
  appearance?: ExtraProps['appearance'];
  matches?: { [k: string]: number };
}

type BlockValue = Pick<Block, 'id'>;

/**
 * Селектор этапа
 */
export const SelectBlock: React.FC<Props> = ({
  instanceId,
  blocks,
  value,
  onChange,
  excludeFormation = true,
  excludeFinished = false,
  className,
  appearance,
  matches,
}) => {
  const selectableBlocks = reject(
    reject(blocks, excludeFormation ? ['type.name', 'formation'] : stubFalse),
    excludeFinished ? ['type.name', 'finished'] : stubFalse,
  );

  const [selectOptions, selectValue, handleChange] = useMultipleValue<
    Block,
    BlockValue,
    BlockOption
  >({
    options: selectableBlocks,
    key: 'id',
    value,
    onChange,
    createOption: (block: Block): BlockOption => ({
      value: block.id,
      label: block.title || '',
      group: block.type?.title || '',
      matches: matches?.[block.id] || 0,
    }),
  });

  const groupedBlockOptions: GroupedBlockOption[] = map(
    groupBy(selectOptions, 'group'),
    (groupedBlocks, group) => ({
      label: group,
      options: groupedBlocks,
    }),
  );

  const formatOptionLabel = useMatchesLabel<BlockOption>();

  return (
    <Select
      instanceId={instanceId}
      placeholder="Этап"
      value={selectValue}
      onChange={handleChange}
      options={groupedBlockOptions}
      className={className}
      isMulti={true}
      isSearchable={false}
      isClearable={false}
      appearance={appearance}
      formatOptionLabel={formatOptionLabel}
    />
  );
};
